import { db } from '../firebase';
import firebase from 'firebase/app';

const PAGE_SIZE = 50;

export async function getProphets({ page = 1, pageSize = 20 } = {}) {
  const snapshot = await db.collection('prophet_stories').get();
  let items = snapshot.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter(item => !item.isDeleted);

  items.sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0));

  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const validPage = Math.max(1, Math.min(page, totalPages));
  const startIndex = (validPage - 1) * pageSize;
  const paginatedItems = items.slice(startIndex, startIndex + pageSize);

  return {
    items: paginatedItems,
    total,
    totalPages,
    page: validPage,
    pageSize,
    hasMore: startIndex + pageSize < total
  };
}

export async function getPrevProphets() {
  return { items: [] };
}

export async function getProphetById(id) {
  const doc = await db.collection('prophet_stories').doc(id).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
}

export async function createProphet(data) {
  const maxOrder = await db.collection('prophet_stories').orderBy('orderIndex', 'desc').limit(1).get();
  const orderIndex = maxOrder.empty ? 0 : (maxOrder.docs[0].data().orderIndex || 0) + 1;
  return db.collection('prophet_stories').add({
    ...data,
    orderIndex,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    created_at: firebase.firestore.FieldValue.serverTimestamp(),
    updated_at: "",
    deleted_at: "",
  });
}

export async function updateProphet(id, data) {
  return db.collection('prophet_stories').doc(id).update({
    ...data,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updated_at: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function deleteProphet(id) {
  return db.collection('prophet_stories').doc(id).update({
    isDeleted: true,
    deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    deleted_at: firebase.firestore.FieldValue.serverTimestamp()
  });
}

export async function reorderProphet(id, newOrderIndex) {
  return db.collection('prophet_stories').doc(id).update({ orderIndex: newOrderIndex });
}

export async function getAllProphets() {
  const snapshot = await db.collection('prophet_stories').orderBy('orderIndex').get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getTotalProphets() {
  const snapshot = await db.collection('prophet_stories').get();
  return snapshot.size;
}

// Chapter Services
export async function getProphetChapters(prophetId) {
  const snapshot = await db
    .collection('prophet_stories')
    .doc(prophetId)
    .collection('chapters')
    .orderBy('orderIndex')
    .get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getChapterById(prophetId, chapterId) {
  const doc = await db
    .collection('prophet_stories')
    .doc(prophetId)
    .collection('chapters')
    .doc(chapterId)
    .get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
}

export async function createChapter(prophetId, data) {
  const chaptersCol = db.collection('prophet_stories').doc(prophetId).collection('chapters');
  const maxOrder = await chaptersCol.orderBy('orderIndex', 'desc').limit(1).get();
  const orderIndex = maxOrder.empty ? 0 : (maxOrder.docs[0].data().orderIndex || 0) + 1;
  return chaptersCol.add({
    ...data,
    orderIndex,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function updateChapter(prophetId, chapterId, data) {
  return db
    .collection('prophet_stories')
    .doc(prophetId)
    .collection('chapters')
    .doc(chapterId)
    .update({
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
}

export async function deleteChapter(prophetId, chapterId) {
  return db
    .collection('prophet_stories')
    .doc(prophetId)
    .collection('chapters')
    .doc(chapterId)
    .delete();
}

export async function reorderChapter(prophetId, chapterId, newOrderIndex) {
  return db
    .collection('prophet_stories')
    .doc(prophetId)
    .collection('chapters')
    .doc(chapterId)
    .update({ orderIndex: newOrderIndex });
}

